import { saveAs } from "file-saver"

const previewTypes = {
  jpg: "image", jpeg: "image", png: "image", webp: "image", gif: "image", avif: "image", heic: "image", heif: "image",
  pdf: "pdf", txt: "text", csv: "text", mp4: "video", m4v: "video", webm: "video", mov: "video", "3gp": "video",
}

export function isFlutterApp() {
  return typeof window !== "undefined" && Boolean(window.flutter_inappwebview)
}

export function attachmentPreviewKind(att) {
  if (!att || (att.type === "video" && att.provider !== "cloudflare_r2")) return ""
  const ext = String(att.originalName || "").split(".").pop().toLowerCase()
  return previewTypes[ext] || ""
}

export async function fetchSignedAttachment(url) {
  if (!/^https:\/\//.test(url || "")) throw new Error("Ungültiger Download-Link.")
  // Never forward the app's Authorization header to storage.
  const response = await fetch(url, { credentials: "omit", referrerPolicy: "no-referrer" })
  if (!response.ok) throw new Error("Die Datei konnte nicht geladen werden.")
  return response.blob()
}

export async function saveAttachmentBlob(blob, filename) {
  if (!isFlutterApp()) return saveAs(blob, filename)
  const bridge = window.flutter_inappwebview
  if (typeof bridge.callHandler !== "function") throw new Error("Der App-Download ist noch nicht bereit. Bitte erneut versuchen.")
  const safeName = String(filename || "datei").replace(/[\\/\0]/g, "_").trim() || "datei"
  const dot = safeName.lastIndexOf(".")
  const extension = (dot > 0 ? safeName.slice(dot + 1) : "bin").replace(/[^a-z0-9]/gi, "").toLowerCase() || "bin"
  const name = dot > 0 ? safeName.slice(0, dot) : safeName
  const base64 = await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => reject(new Error("Die Datei konnte nicht für die App vorbereitet werden."))
    reader.onabort = reader.onerror
    reader.onload = () => {
      const value = String(reader.result || "").split(",")[1]
      if (value) resolve(value)
      else reject(new Error("Die Datei ist leer oder konnte nicht gelesen werden."))
    }
    reader.readAsDataURL(blob)
  })
  const result = await bridge.callHandler("blobToBase64Handler", base64, extension, name)
  if (result === false || result?.success === false) throw new Error("Die App konnte die Datei nicht öffnen.")
}
